// Items won, not bought (the Royale's crown: core shop-catalog `exclusive`),
// that the player has not looked at yet: a gold count on the navbar's Store
// and on its Worm Heads tab, and the item glowing until it is opened there
// (then its unlock moment plays once). "Seen" is kept on this device; what is
// owned comes from the Store's own cache (local-cache.ts), so nothing is fetched.
import { useEffect, useState } from "react";
import { readShopCache } from "./local-cache";
import { EXCLUSIVE_ITEMS, ownsItem } from "./store";

const KEY = "ar.seenUnlocks";
const EVENT = "ar:unlocks";

function seen(): Set<string> {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { return new Set(); }
}

// The won items not seen yet.
export function newUnlocks(): { kind: string; id: string; label: string }[] {
  const cache = readShopCache();
  if (!cache) return [];
  const s = seen();
  return EXCLUSIVE_ITEMS.filter((i) => ownsItem(cache.owned, i.kind, i.id) && !s.has(i.id)).map((i) => ({ kind: i.kind, id: i.id, label: i.label }));
}

export function isNewUnlock(id: string): boolean {
  return newUnlocks().some((u) => u.id === id);
}

// It has been seen (its unlock moment played): no more count or glow.
export function markUnlockSeen(id: string): void {
  try {
    const s = seen();
    if (s.has(id)) return;
    s.add(id);
    localStorage.setItem(KEY, JSON.stringify([...s]));
  } catch { /* storage blocked: it stays new this session */ }
  announceUnlocks();
}

// Something changed (the Store's owned cache, a seen item): readers look again.
export function announceUnlocks(): void {
  try { window.dispatchEvent(new Event(EVENT)); } catch { /* no window */ }
}

export function useNewUnlocks(): { kind: string; id: string; label: string }[] {
  const [list, setList] = useState(newUnlocks);
  useEffect(() => {
    const again = () => setList(newUnlocks());
    window.addEventListener(EVENT, again);
    window.addEventListener("storage", again);
    window.addEventListener("focus", again);
    return () => { window.removeEventListener(EVENT, again); window.removeEventListener("storage", again); window.removeEventListener("focus", again); };
  }, []);
  return list;
}
